import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters'
import * as actions from './actions'
import auth from './module/auth'
import carts from './module/carts'
import orders from './module/orders'
import global from './module/global'
import product from './module/product'
import commission from './module/commission'
import article from './module/article'

import orderList from './module/order_list'
import orderPay from './module/order_pay'

import combine from './module/combine'

Vue.use(Vuex)

export default new Vuex.Store({
  getters,
  actions,
  modules: {
    auth,
    carts,
    // orders,
    orderList,
    orderPay,
    global,
    product,
    commission,
    article,
    combine
  }
  // 注意：
  // 在发布时需要注释该行，以免影响性能！
  // strict: true
})



// WEBPACK FOOTER //
// ./src/store/index.js